// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"bbf_a"};